import * as React from 'react'
import styled from 'styled-components'

import * as model from '@owl-nest/models'
import * as layout from '../layout'
import { Button, LinkAsButton, styles as S, VideoLoader } from '@ulule/owl-kit-components/next'
import { t, tc } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'

const OffboardingFundedWrapper = styled(layout.Coach)`
  ${VideoLoader} {
    margin: 14px 0;
  }
  ${Button} {
    width: 100%;
  }
`

type OffboardingFundedProps = {
  initialOpen: boolean
  project: projectModel.Project
  markStepSeen: () => Promise<void>
}

export function OffboardingSuccess({
  project,
  markStepSeen,
  initialOpen,
}: OffboardingFundedProps): React.ReactElement<OffboardingFundedProps> | null {
  const manager = project.manager || project.default_manager

  const [open, setIsOpen] = React.useState(initialOpen)

  if (manager === undefined) {
    return null
  }

  const managerAvatar = model.image.getUrl(manager.avatar.versions, '128x128')

  return (
    <OffboardingFundedWrapper
      closable={true}
      open={open}
      title={t('Successfully funded!')}
      onClose={handleDone}
      avatar={managerAvatar}
    >
      <S.copy.S.regular>
        {tc(
          `You’ve got an audience 👋 [br][br] An audience is still being drawn to your page. Give that latecomers a chance to back or follow your project! Let’s do this together!`,
          {
            br: <br />,
          },
        )}
      </S.copy.S.regular>

      <Button onClick={goToOffboarding}>{t('Update your page now')}</Button>

      <LinkAsButton kind="secondary" onClick={handleDone}>
        {t('Later')}
      </LinkAsButton>
    </OffboardingFundedWrapper>
  )

  function handleDone(): void {
    setIsOpen(false)
    markStepSeen()
  }

  async function goToOffboarding(): Promise<void> {
    await markStepSeen()
    window.location.href = `/projects/${project.id}/backoffice/offboarding/`
  }
}
